import { createSelector } from '@ngrx/store';
import { AppState } from '../../app.state';
import { MainState } from '../reducers/main.reducer';

export const selectMainState = (state: AppState) => state.main;

export const selectNotes = createSelector(
  selectMainState,
  (state: MainState) => state.notes
);

export const selectSelectedNote = createSelector(
  selectMainState,
  (state: MainState) => state.selectedNote
);

export const selectNoteFilters = createSelector(
  selectMainState,
  (state: MainState) => state.noteFilters
);

export const selectActiveNoteFilters = createSelector(
  selectMainState,
  (state: MainState) => state.activeNoteFilters
);
